import { useKundliProfilesStore } from './kundliProfilesStore';
import { useInsightsStore } from './insightsStore';
import { useChatStore } from './chatStore';

/**
 * Clears all cached data from stores.
 * Call this on logout or when user switches accounts.
 */
export const clearAllCaches = () => {
    useKundliProfilesStore.getState().clearCache();
    useInsightsStore.getState().clearCache();
    useChatStore.getState().clearSessionsCache();
};
